import "./Practise.css";

const Practise = () => {
  const alerts = () => {
    alert("I write code");
  };

  const prompt = () => {
    setTimeout(() => {
      alert("I write code");
    }, 5000);
  };

  function allowDrop(ev: any) {
    ev.preventDefault();
  }

  function drag(ev: any) {
    ev.dataTransfer.setData("text", ev.target.id);
  }

  function drop(ev: any) {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("text");
    ev.target.appendChild(document.getElementById(data));
  }

  return (
    <div className="container">
      <div className="test">
        {" "}
        <h3>Iframe</h3>
        <iframe
          src="https://ineuron-courses.vercel.app/"
          width={1000}
          height={500}
        ></iframe>
      </div>

      <div className="test">
        {" "}
        <h3>Alert</h3>
        <button className="practiseBtn" onClick={alerts}>Click to show</button>
      </div>
      <div className="test">
        <h3>Alert after 5s</h3>
        <button className="practiseBtn" onClick={prompt}>Click to see after 5s</button>
      </div>
      <div className="test">
        <h3>Drag n Drop</h3>
        <div
          className="dragDiv"
          id="drag1"
          draggable="true"
          onDragStart={(e) => drag(e)}
        ></div>
        <div
          id="div1"
          onDrop={(e) => drop(e)}
          onDragOver={(e) => allowDrop(e)}
        ></div>
      </div>
    </div>
  );
};

export default Practise;
